import { fetchWrapper } from "@/helpers";

const ruta = process.env.VUE_APP_ROOT_API;

export default class facturaService {
  async nuevaFactura(datos) {
    const factura = await fetchWrapper.put(`${ruta}/facturar`, datos);
    return factura;
  }
}